module.exports = __webpack_public_path__ + "img/yzappfw2.74924cab.png";